export default "__VITE_ASSET__Xt$1txsy__"